<template>
  <section class="participants-container">
    <h3 class="participants__title">
      {{ title }}
    </h3>
    <form
      v-if="!isAddParticipantsOpen"
      @submit.prevent="handleSubmit"
      class="participants-form">
      <people-list
        class="people-list"
        :users="userSelectedContacts"
        :show-delete-button="true"
        :enable-access-check="false"
        :check-user-amount="false"
        message="dont show"
        :disable-focus="true"
        :show-add-button="false"
        :show-user-phone="true"
        @deleteUser="deleteUser"
        :lock-user-deletion="lockUserDeletion"
      />
      <add-human-button
        variant="add"
        class="add-participants-button"
        v-if="!isAddParticipantsOpen"
        @clicked="toggleAddParticipants"
      />
<!--      <div-->
<!--        v-if="!isAddParticipantsOpen"-->
<!--        class="form-buttons">-->
<!--        <button-app-->
<!--          @clicked="cancelSubmit"-->
<!--          type="button"-->
<!--          class="form-button form-button_left"-->
<!--          color-scheme="gray"-->
<!--        >-->
<!--          {{ $t('CP.cancel') }}-->
<!--        </button-app>-->
<!--        <button-app-->
<!--          type="submit"-->
<!--          class="form-button"-->
<!--          color-scheme="blue"-->
<!--        >-->
<!--          {{ $t('CP.save') }}-->
<!--        </button-app>-->
<!--      </div>-->
    </form>
<!--    <add-user-contact-participants-form-->
<!--      v-else-if="isAddParticipantsOpen"-->
<!--      class="add-participants-form"-->
<!--      @submit="toggleAddParticipants"-->
<!--      @cancel="toggleAddParticipants"-->
<!--    />-->
  </section>
</template>

<script>
import { mapState } from 'vuex';
import {
  SET_FINAL_USER_SELECTED_CONTACTS,
  DELETE_USER_SELECTED_CONTACTS,
} from '@/store/user/types';
// import ButtonApp from '../../components/Button/ButtonApp';
import PeopleList from '../../components/PeopleList/PeopleList';
import AddHumanButton from '../../components/AddHumanButton/AddHumanButton';
// import AddUserContactParticipantsForm
//   from '../AddUserContactParticipantsForm/AddUserContactParticipantsForm';

export default {
  name: 'UserContactParticipantsForm',
  components: {
    // AddUserContactParticipantsForm,
    AddHumanButton,
    PeopleList,
    // ButtonApp,
  },
  props: {
    title: {
      type: String,
      default() {
        return this.$t('CP.participants');
      },
    },
    lockUserDeletion: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isAddParticipantsOpen: false,
    };
  },
  watch: {
    userSelectedContacts() {
      this.$store.commit(SET_FINAL_USER_SELECTED_CONTACTS, this.userSelectedContacts);
    },
  },
  computed: {
    ...mapState({
      userPhone: (state) => state.user.user.phone,
      userSelectedContacts: (state) => state.user.userSelectedContacts,
      finalUserSelectedContacts: (state) => state.user.finalUserSelectedContacts,
    }),
  },
  methods: {
    cancelSubmit() {
      this.$bvModal.hide('user-contact-participants');
    },
    handleSubmit() {
      this.$store.commit(SET_FINAL_USER_SELECTED_CONTACTS, this.userSelectedContacts);
      this.$bvModal.hide('user-contact-participants');
    },
    deleteUser(user) {
      this.$store.commit(DELETE_USER_SELECTED_CONTACTS, user);
    },
    toggleAddParticipants() {
      // this.isAddParticipantsOpen = !this.isAddParticipantsOpen;
      // this.$emit('toggleAddParticipants');
      this.$bvModal.show('add-user-contact-participants');
    },
  },
};
</script>

<style scoped>
.participants-container {
  color: var(--text-main-color);
}
.participants-form {
  padding: 0 calc(32px - 1rem);
}
.participants__title {
  margin: 0 0 26px;
}
.people-list {
  margin: 0 0 30px;
  max-height: 50vh;
}
.add-participants-button {
  margin: 0 0 30px;
}
.add-participants-form {
  padding: 0;
}
.form-buttons {
  display: flex;
}
.form-button {
  font-size: 13px;
  font-weight: bold;
  height: 38px;
  flex: 1 0 40%;
  margin: 0;
}
.form-button_left {
  margin: 0 8px 0 0;
}
</style>
